export default __webpack_public_path__ + "static/6-693ca644a86c052f7e0ce3e8b6420f91.jpg";